import { A } from '@main/core-ui';
import React from 'react';
import { useIntl } from 'react-intl';

import { CodeEditor } from '../../CodeEditor';
import { enableCustomFunctionDenoMode } from '../editor-config';
import { customFunctionMessages } from '../messages';
import type { EnvironmentVariable } from '../types';
import { DescriptionWrapper } from '../wrappers';
import { Environment } from './shared';

// JSX links injected into messages (see messages.ts)
const Deno = (
  <A
    href="https://deno.com/"
    message={customFunctionMessages.deno}
    style={{ fontWeight: 'inherit' }}
  />
);
const ImportThirdPartyDeps = (
  <A
    href="https://docs.deno.com/runtime/fundamentals/modules/#importing-third-party-modules-and-libraries"
    style={{ fontWeight: 'inherit' }}
    message={customFunctionMessages.importThirdPartyDeps}
  />
);
const DenoPermissions = (
  <A
    href="https://docs.deno.com/runtime/fundamentals/security/"
    style={{ fontWeight: 'inherit' }}
    message={customFunctionMessages.denoPermissions}
  />
);

interface CodeEditorTabProps {
  /** The code string */
  value: string;
  /** The callback function to handle changes to the code string */
  onChange: (code: string) => void;
  /** The env vars set in the Environment Variables tab */
  envVars: EnvironmentVariable[];
}

export const CodeEditorTab: React.FC<CodeEditorTabProps> = ({
  value,
  onChange,
  envVars,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <DescriptionWrapper>
        {formatMessage(customFunctionMessages.codeEditorInstructions, {
          Deno,
          ImportThirdPartyDeps,
          DenoPermissions,
          Environment,
        })}
      </DescriptionWrapper>
      <div style={{ flexGrow: 1, overflow: 'hidden', minHeight: '50px' }}>
        <CodeEditor
          height="100%"
          language="typescript"
          filename="custom-function.ts"
          defaultValue={value}
          onChange={onChange}
          onMount={(editor, monaco) => {
            enableCustomFunctionDenoMode(monaco, envVars);
          }}
        />
      </div>
    </>
  );
};
